var EmailPrefs = {

  defaultEmailPrompt: document.querySelector('.js-no-email-prompt'),
  updateEmailPrompt: document.querySelector('.js-email-prompt'),
  emailPlaceholder: document.querySelector('.js-email-placeholder'),

  prefsLink: document.querySelector('.js-email-prefs'),

  init: function() {
    if (!this.prefsLink) { return; }

    var params = this.getQueryParams();

    if (params.prefs_url) {
      this.showPrefsLink(params.prefs_url);
    }

    if (params.email) {
      this.showEmailPrompt(params.email);
    }
  },

  getQueryParams: function() {
    var params = {};

    window.location.search.replace('?', '')
                          .split('&')
                          .forEach(function(value) {
      var kv = value.split('=');

      params[kv[0]] = decodeURIComponent(kv[1]);
    });

    return params;
  },

  showPrefsLink: function(url) {
    this.prefsLink.href = url;
    this.prefsLink.classList.remove('hidden');
  },

  showEmailPrompt: function(email) {
    this.emailPlaceholder.innerHTML = email;
    this.defaultEmailPrompt.classList.add('hidden');
    this.updateEmailPrompt.classList.remove('hidden');
  }

};

window.addEventListener('load', function() {
  EmailPrefs.init();
});